import {
    SEARCH_MENU_AND_ITEMS_START,
    SEARCH_MENU_AND_ITEMS_SUCCESS,
    SEARCH_MENU_AND_ITEMS_ERROR,
} from '../constants';

const initialState = {
    searchResults: null,
    loading: false,
};

export default function menu(state = initialState, action) {
    switch (action.type) {

        case SEARCH_MENU_AND_ITEMS_START:
            return {
                ...state,
                loading: true,
            };

        case SEARCH_MENU_AND_ITEMS_SUCCESS:
            return {
                ...state,
                searchResults: action.payload,
                loading: false,
            };

        case SEARCH_MENU_AND_ITEMS_ERROR:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
}
